import { Component } from '@theme/component';
import { SlideshowSelectEvent } from '@theme/events';

/**
 * ProductListTabs component
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} tabs
 *
 * @extends {Component<Refs>}
 */
export class ProductListTabs extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.refs.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.#onTabClick(tab));
    });

    this.#showCollection(this.refs.tabs[0]?.getAttribute('data-collection-handle'));
  }

  #onTabClick(tab) {
    this.refs.tabs.forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');
    this.#showCollection(tab.getAttribute('data-collection-handle'));
  }

  #showCollection(handle) {
    this.parentNode.querySelectorAll('product-card[data-collection-handle]').forEach(card => {
      if (card.closest('slideshow-slide') !== null) {
        card.closest('slideshow-slide').style.display = card.getAttribute('data-collection-handle') === handle ? '' : 'none';
        card.closest('slideshow-slide').style.visibility = card.getAttribute('data-collection-handle') === handle ? '' : 'hidden';
      }

      const cardGallery = card.querySelector('[ref="cardGallery"] > slideshow-component') || card.querySelector('[ref="cardGalleryLink"] > slideshow-component');

      cardGallery?.updateVisibleSlides();
    });

    const productCarousel = this.parentNode.querySelector('slideshow-component[ref="resourceListCarousel"]');

    const slides = productCarousel.querySelectorAll(':scope > slideshow-container > slideshow-slides > slideshow-slide');

    const visibleSlide = Array.from(slides).find(slide => {
      const style = window.getComputedStyle(slide);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });

    const visibleIndex = Array.from(slides).indexOf(visibleSlide);

    if (visibleSlide) {
      productCarousel.select(visibleIndex, null, {animate: false});
    }
  }
}

if (!customElements.get('product-list-tabs')) {
  customElements.define('product-list-tabs', ProductListTabs);
}